
// This allows us to only load a JS script when it's required

export default {
  name: 'ScriptLoader',

  props: {
    scripts: {
      type: Array,
      required: true
    },

    css: {
      type: Array,
      default: null
    }
  },

  data() {
    return {
      hasLoaded: false,
      isErrorLoading: false
    }
  },

  mounted() {
    if (this.scripts) {
      this.loadAllScripts()
    }

    if (this.css) {
      this.loadAllCss()
    }
  },

  methods: {
    async loadAllScripts() {
      const promises = this.scripts.map(script => this.loadScript(script.id, script.url))

      try {
        await Promise.all(promises)
        this.hasLoaded = true

        this.$emit('ready')
      } catch (error) {
        this.isErrorLoading = true
        this.$emit('error')
      }
    },

    async loadAllCss() {
      const promises = this.css.map(css => this.loadCss(css.id, css.url))

      try {
        await Promise.all(promises)
      } catch (error) {
        this.isErrorLoading = true
        this.$log.error('Failed to load css', error)
      }
    },

    loadScript(scriptId, scriptUrl) {
      return new Promise((resolve, reject) => {
        const scriptElement = document.getElementById(scriptId)

        // If we have already injected the script
        if (scriptElement) {
          this.$nextTick(() => resolve())
        }

        const script = document.createElement('script')

        script.src = scriptUrl
        script.id = scriptId
        script.type = 'text/javascript'

        script.addEventListener(
          'load',
          () => {
            this.$nextTick(() => resolve())
          },
          {
            once: true
          }
        )

        script.addEventListener(
          'error',
          event => {
            this.$log.error(`Error loading ${this.scriptId} script`, event)

            reject(event)
          },
          { once: true }
        )

        document.head.appendChild(script)
      })
    },

    loadCss(cssId, cssUrl) {
      return new Promise((resolve, reject) => {
        const existingLink = document.getElementById(cssId)

        // If we have already injected the css
        if (existingLink) {
          this.$nextTick(() => resolve())
        } else {
          const link = document.createElement('link')

          link.setAttribute('rel', 'stylesheet')
          link.setAttribute('href', cssUrl)
          link.setAttribute('id', cssId)
          link.setAttribute('type', 'text/css')
          document.head.appendChild(link)
        }
      })
    }
  }
}
